import { AddCircle, RemoveCircle, Update } from "@mui/icons-material"
import { Box, Typography } from "@mui/material"
import theme from "../../../theme"

export type Change = 'Replaced' | 'Removed' | 'Added'

export const changeValues: Change[] = ['Removed', 'Added'];

const getChangeColor = (change: Change): string => {
  switch (change) {
    case 'Replaced':
      return theme.palette.warning.main;
    case 'Removed':
      return theme.palette.error.main;
    case 'Added':
      return theme.palette.success.main;
    default:
      return 'black';
  }
};

export const getDisplayText = (change: Change) : string => {
  switch(change){
    case "Added" : return "Add new item inside"
    case "Removed" : return "Remove"
    case "Replaced" : return "Replace"
    default : return ""
  }
}

export const getShortText = (change: Change) : string => {
  switch(change){
    case "Added" : return "add"
    case "Removed" : return "remove"
    case "Replaced" : return "replace"
    default : return ""
  }
}

export const ChangeChip = ({changeValue}:{changeValue:Change}) => {
  return (
    <Box sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center', gap: 1}}>
      <ChangeIcon changeValue={changeValue}/>
      <Typography sx={{color: getChangeColor(changeValue)}}>
        {changeValue}
      </Typography>
    </Box>
  )
}

export const ChangeIcon = ({changeValue}:{changeValue: Change}) => {
  return(
    <Box sx={{display: 'flex', alignItems: 'center'}}>
      {
        changeValue === 'Added' ? <AddCircle sx={{color: getChangeColor('Added')}}/> 
          : changeValue === 'Removed' ? <RemoveCircle sx={{color: getChangeColor('Removed')}}/> 
            : <Update sx={{color: getChangeColor('Replaced')}}/>
      }
    </Box>
  )

}